import rosetta from "rosetta";

import EN from "./locales/en";
import ZH from "./locales/zh";

const ramda = require("ramda");

const i18n = rosetta({
  en: EN,
  zh: ramda.mergeDeepLeft(ZH, EN),
});

// Set default language
// TODO: Stick this in a context, use cookies/user settings, etc
i18n.locale("en");

const t = i18n.t;

export default t;
